import { render, staticRenderFns } from "./workspace.vue?vue&type=template&id=487bc4f9&"
import script from "./workspace.vue?vue&type=script&lang=js&"
export * from "./workspace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports